import React from "react";
import { Box, Heading, Link, List, ListItem, Text } from "@chakra-ui/react";

import Seo from "../seo/Seo";
import { SERVICES } from "../seo/schema";

/**
 * Real 404 page.
 *
 * Previously every unknown URL was redirected to "/", which search engines
 * treat as a soft 404: the bad URL stays indexed, and crawl budget is spent
 * re-fetching it. Serving a noindex page with links back into the site is the
 * correct signal.
 *
 * Note: this still returns HTTP 200 because the app is a static SPA. If the
 * host supports it, configure a genuine 404 status for unmatched paths.
 */
const NotFound = () => (
  <Box bg="#fceee5" minH="60vh">
    <Seo
      title="Page Not Found | Qualiteeth Dental Care"
      description="The page you are looking for could not be found. Browse our dental treatments or contact Qualiteeth Dental Care, Vaishali Nagar, Jaipur."
      noindex
    />
    <Box maxW="3xl" mx="auto" py={16} px={4} marginTop="80px">
      <Heading as="h1" fontSize={{ base: "2xl", md: "4xl" }} fontWeight="light" mb={4}>
        We couldn't find that page
      </Heading>
      <Text fontWeight="light" mb={6}>
        The page may have moved or the link may be out of date. Here is what you
        can do instead:
      </Text>
      <List spacing={2} styleType="disc" pl={4}>
        <ListItem>
          <Link href="/" fontWeight="bold">
            Go to the homepage
          </Link>
        </ListItem>
        {SERVICES.map((service) => (
          <ListItem key={service.path}>
            <Link href={service.path}>{service.name}</Link>
          </ListItem>
        ))}
        <ListItem>
          <Link href="/blog">Dental health blog</Link>
        </ListItem>
      </List>
      <Text mt={6} fontWeight="light">
        Or call the clinic on{" "}
        <Link href="tel:+919256491206" fontWeight="bold">
          (+91) 92564 91206
        </Link>
        .
      </Text>
    </Box>
  </Box>
);

export default NotFound;
